import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HelpButton = function (_a) {
    var onClick = _a.onClick;
    return (_jsx("div", { className: "inline relative flex ltr:right-[-12px] rtl:left-[-12px]", style: {
            position: "fixed",
            top: "53%",
            zIndex: 10002,
        }, children: _jsxs("button", { onClick: onClick, className: "font-bold cursor-pointer inline bg-primaryColor", style: {
                fontSize: "12px",
                cursor: "pointer",
                color: "white",
                display: "block",
                padding: "2px 7px",
                transform: "rotate(90deg)",
                borderRadius: "5px",
            }, children: [_jsx("span", { children: "H" }), _jsx("span", { children: "E" }), _jsx("span", { children: "L" }), _jsx("span", { children: "P" })] }) }));
};
export default HelpButton;
